import { render, staticRenderFns } from "./WineListBrochure.vue?vue&type=template&id=c83324f0&"
import script from "./WineListBrochure.vue?vue&type=script&lang=js&"
export * from "./WineListBrochure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports